export default "/images/corner-down-left.svg?c0e4e5bcbff6dece0b25379aa12f837f";